import React, { useState } from "react";
import { Avatar, Box, Paper, Typography } from "@mui/material";
import {
  eachDayOfInterval,
  endOfMonth,
  endOfWeek,
  isSameDay,
  isSameMonth,
  startOfMonth,
  startOfWeek,
} from "date-fns";
import BatchChip from "./BatchChip";

const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

const MonthView = ({ cursor, eventsByDate, onBatchClick }) => {
  const today = new Date();
  const [expandedDays, setExpandedDays] = useState({});
  const days = eachDayOfInterval({
    start: startOfWeek(startOfMonth(cursor), { weekStartsOn: 0 }),
    end: endOfWeek(endOfMonth(cursor), { weekStartsOn: 0 }),
  });

  return (
    <Paper variant="outlined" elevation={0} sx={{ borderRadius: 3, overflow: "hidden" }}>
      <Box sx={{ display: "grid", gridTemplateColumns: "repeat(7, minmax(0, 1fr))" }}>
        {dayNames.map((day) => (
          <Box
            key={day}
            sx={{
              p: 1,
              borderRight: "1px solid",
              borderColor: "divider",
              bgcolor: "grey.100",
              "&:last-of-type": { borderRight: "none" },
            }}
          >
            <Typography variant="caption" sx={{ fontWeight: 700 }}>
              {day}
            </Typography>
          </Box>
        ))}
      </Box>

      <Box sx={{ display: "grid", gridTemplateColumns: "repeat(7, minmax(0, 1fr))" }}>
        {days.map((day, idx) => {
          const key = day.toISOString().slice(0, 10);
          const events = eventsByDate[key] || [];
          const isExpanded = Boolean(expandedDays[key]);
          const visibleEvents = isExpanded ? events : events.slice(0, 3);
          return (
            <Box
              key={key}
              sx={{
                minHeight: 90,
                p: 1,
                borderTop: "1px solid",
                borderRight: idx % 7 === 6 ? "none" : "1px solid",
                borderColor: "divider",
                opacity: isSameMonth(day, cursor) ? 1 : 0.55,
              }}
            >
              <Box sx={{ mb: 0.5 }}>
                {isSameDay(day, today) ? (
                  <Avatar sx={{ width: 24, height: 24, fontSize: 12, bgcolor: "primary.main" }}>
                    {day.getDate()}
                  </Avatar>
                ) : (
                  <Typography variant="caption">{day.getDate()}</Typography>
                )}
              </Box>

              {visibleEvents.map((batch) => (
                <BatchChip key={`${key}-${batch.id}`} batch={batch} onClick={onBatchClick} />
              ))}
              {events.length > 3 && !isExpanded ? (
                <Typography variant="caption" color="text.secondary">
                  <Box
                    component="span"
                    sx={{ cursor: "pointer", color: "primary.main", fontWeight: 500 }}
                    onClick={() =>
                      setExpandedDays((prev) => ({ ...prev, [key]: true }))
                    }
                  >
                    +{events.length - 3} more
                  </Box>
                </Typography>
              ) : null}
              {events.length > 3 && isExpanded ? (
                <Typography variant="caption" color="text.secondary">
                  <Box
                    component="span"
                    sx={{ cursor: "pointer", color: "primary.main", fontWeight: 500 }}
                    onClick={() =>
                      setExpandedDays((prev) => ({ ...prev, [key]: false }))
                    }
                  >
                    Show less
                  </Box>
                </Typography>
              ) : null}
            </Box>
          );
        })}
      </Box>
    </Paper>
  );
};

export default MonthView;

